import ApplicationController from './application_controller'

export default class extends ApplicationController {
  connect() {
    super.connect()
  }

  cancelBid(e) {
    e.preventDefault()
    e.target.disabled = true

    // Only decrement if this is the acting user's own bid — an admin can cancel anyone's.
    const isOwnBid = window.givsum_user_id && this.element.dataset.bidderId &&
      String(this.element.dataset.bidderId) === String(window.givsum_user_id)

    this.stimulate('CancelBidReflex#cancel_bid').then(() => {
      document.body.classList.remove('wait')
      if (isOwnBid) decrementMyBidsTabCount()
    }).catch(() => {
      // Harmless: CableReady can replace the trigger row before the reflex promise settles.
      document.body.classList.remove('wait')
    })
  }
}

function decrementMyBidsTabCount() {
  const countEl = document.querySelector('#my-bids-tab .tab-count')
  if (!countEl) return
  const match = countEl.textContent.match(/\d+/)
  const current = match ? parseInt(match[0], 10) : 0
  countEl.textContent = `(${Math.max(0, current - 1)})`
}
